<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("bills.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("bills.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                        serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="bill.description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    rows="2"
                    :error="
                      errors.first('description') != null ||
                        serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                        serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.amount"
                    name="amount"
                    label="Amount"
                    type="number"
                    v-validate="'required|numeric|max_value:9999999'"
                    :error="
                      errors.first('amount') != null ||
                        serverSideErrors.amount != null
                    "
                    :error-messages="
                      errors.first('amount') || serverSideErrors.amount
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.amount_for_rental"
                    name="amount_for_rental"
                    label="Amount For Rental"
                    type="number"
                    v-validate="'numeric|max_value:9999999'"
                    :error="
                      errors.first('amount_for_rental') != null ||
                        serverSideErrors.amount_for_rental != null
                    "
                    :error-messages="
                      errors.first('amount_for_rental') ||
                        serverSideErrors.amount_for_rental
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="documents"
                    label="Bill Documents"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    hint="Only jpg, png, gif, pdf, jpeg, svg file types are allowed"
                    persistent-hint
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-row v-if="bill.documents.length > 0">
                    <v-col
                      v-for="item in bill.documents"
                      :key="item.document_url"
                      class="d-flex child-flex"
                      cols="6"
                      sm="6"
                      md="2"
                    >
                      <v-card>
                        <v-img
                          v-if="item.file_type == 'image'"
                          :src="API_BASE_URL + '/uploads/' + item.document_url"
                          :lazy-src="
                            API_BASE_URL + '/uploads/' + item.document_url
                          "
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                          v-else
                          :src="API_BASE_URL + '/default-pdf.png'"
                          :lazy-src="API_BASE_URL + '/default-pdf.png'"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-actions class="pa-0">
                          <v-btn icon color="secondary" @click="confirmDelete(item.id)">
                            <v-icon small>
                              mdi-close
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon
                            color="secondary"
                            name="view_notice"
                            title="Edit "
                            @click="openDocument(item)"
                            style="float: right"
                          >
                            <v-icon small v-if="item.file_type == 'image'">
                              mdi-eye</v-icon
                            >
                            <v-icon small v-else> mdi-eye</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col>
                      <span>No Documents Available</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveBillDetails"
              :loading="loading"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDocument(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      bill: {
        title: "",
        description: "",
        amount: "",
        amount_for_rental: "",
        documents: [],
      },
      added_documents: [],
      base_url: process.env.VUE_APP_API_URL,
      deleteDialog: false,
      delete_id: null,
      documents: [],
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    saveBillDetails() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          let formData = new FormData();

          formData.append("title",this.bill.title ? this.bill.title : "");
          formData.append("description",this.bill.description ? this.bill.description : "");
          formData.append("amount",this.bill.amount ? this.bill.amount : "");
          formData.append("amount_for_rental",this.bill.amount_for_rental ? this.bill.amount_for_rental : "");

          for(let i=0; i<this.documents.length; i++) {
            formData.append("documents[]",this.documents[i]);
          }

          _self.$axios
            .put("/societyadmin/bills/" + this.bill.id,formData,{
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });

                _self.$router.push({ path: "/societyadmin/bills" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getBillDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/bills/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.bill = data.bill;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    deleteDocument(Id) {
      let _self = this;
      _self.$axios
        .delete(`societyadmin/bills/${_self.$route.params.id}/documents/${Id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getBillDetail();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
    openDocument(item) {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getBillDetail();
  },
};
</script>
